/**
 * Keyboard handler for elements that are interactive via `on:click` but are not natively
 * focusable/activable (e.g. a `<div>` or `<span>` with `role="button"`).
 *
 * Wire it up with `on:keydown={triggerClickOnEnterOrSpace}` next to the existing `on:click`.
 * When the focused element receives Enter or Space, it synthesizes a click on that element,
 * which runs the same `on:click` handler — keeping mouse and keyboard behaviour identical
 * without duplicating the click logic.
 */
export function triggerClickOnEnterOrSpace(event: KeyboardEvent) {
    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") {
        return;
    }
    // Ignore keys that bubbled up from a nested interactive element (input, button, ...):
    // only act when the element carrying the handler is itself focused.
    if (event.target !== event.currentTarget) {
        return;
    }
    event.preventDefault();
    (event.currentTarget as HTMLElement).click();
}
